<template>
  <div class="container-full p-5 pr-2-768 pl-2-768 f-center mb-3 background-border-color border-radius-1">
    <div class="container-546 f-column f-center">
      <div class="f-center f-column mb-children-2 container-full">
        <h3 class="font-big font-light font-center">Váš názor je pre nás dôležitý</h3>

        <stars v-model="rating" :errors="errors" :disable="reviewSent">
          <!--<template slot="validations">
            <div class="error font-center" id="RATING">Zadajte hodnotenie.</div>
          </template>-->
        </stars>

        <div
          class="thank-you-1 mt-3 font-center"
          v-if="reviewSent && rating <= 3 && rating >= 1"
        >
          <p>Ďakujeme. Vášmu hodnoteniu venujeme pozornosť a budeme pracovať na zv‎‎ýšení vašej spokojnosti.</p>
        </div>

        <div
          class="thank-you-2 mt-3 font-center"
          v-if="reviewSent && rating <= 5 && rating >= 4"
        >
          <p>Ďakujeme, teší nás vaša spokojnosť. Radi vás uvidíme aj nabudúce :)</p>
        </div>

        <div
          class="input-box-holder width-10 rate-us-textarea max-width-unset"
          v-validate="errors"
          v-if="!reviewSent"
        >
          <textarea
            :placeholder="reviewPlaceholder"
            v-model="review"
            @focus="reviewFocus = true"
            @blur="reviewFocus = false"
            maxlength="400"
          ></textarea>

          <div class="validation-output"></div>
        </div>

        <button
          :class="{
            'button-darker-gray': errors.length > 0,
            'button-green': errors.length === 0
          }"
          v-if="!reviewSent"
          v-scroll-to-error
          @click="sendReview">
          Odoslať hodnotenie
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiPost } from '@/api';
import Stars from './Stars.vue';

export default {
  name: 'Rating',
  components: {
    Stars,
  },
  props: ['model'],
  data() {
    return {
      rating: 0,
      reviewFocus: false,
      review: '',
      reviewSent: false,
    };
  },
  computed: {
    reviewPlaceholder() {
      if (!this.reviewFocus) {
        return 'Napíšte nám, čo sa Vám pri uzatváraní poistenia páčilo, alebo čo by ste, naopak, zlepšili. Ďakujeme :)';
      }
      return '';
    },
    errors() {
      const errors = [];
      if (this.rating <= 0 && this.review.length === 0) {
        errors.push('RATING');
        errors.push('REVIEW');
      }
      return errors;
    },
  },
  methods: {
    sendReview() {
      if (this.errors) {
        const UAparser = new UAParser(); // eslint-disable-line
        const device = UAparser.getDevice();
        const OS = UAparser.getOS();
        const browser = UAparser.getBrowser();

        const request = new FormData();
        request.set('rating', this.rating);
        request.set('voiceText', this.review);
        request.set('voiceInsuranceType', 'obhliadka');
        request.set('voiceInsuranceTypeNew', 'OBHLIADKA');
        request.set('insuranceNumber', this.$store.getters.getInspection.contractNumber);
        request.set('email', this.$store.getters.getEmail);
        request.set('device', device.type ? device.type : 'PC');
        request.set('os', OS.name);
        request.set('osVersion', OS.version);
        request.set('browser', browser.name);
        request.set('browserVersion', browser.version);
        request.set('useragent', navigator.userAgent);

        apiPost('/app/contact/sendFormVoice.js', request).then(() => {
          this.reviewSent = true;
        });
      }
    },
  },
};
</script>

<style>
textarea {
  resize: none;
}
</style>
